import { useMemo } from 'react';
import { createUseStyles as jssCreateUseStyles } from 'react-jss';
import { clsx } from '.';

function createUseStyles(styles) {
  function deferredUseStyles(finalStyles) {
    const jssUseStyles = jssCreateUseStyles(finalStyles);

    const useStyles = (classesProp, ...styleParams) => {
      const baseClasses = jssUseStyles(...styleParams);
      const classes = useMemo(() => {
        if (!classesProp) {
          return baseClasses;
        }

        return Object.entries(classesProp).reduce((mergedClasses, [additionalClassKey, additionalClassName]) => {
          const baseClassName = mergedClasses[additionalClassKey];

          if (additionalClassName) {
            return { ...mergedClasses,
              [additionalClassKey]: baseClassName ? clsx(baseClassName, additionalClassName) : additionalClassName
            };
          }

          return mergedClasses;
        }, baseClasses);
      }, [classesProp, ...styleParams]);
      return classes;
    };

    return useStyles;
  }

  return styles ? deferredUseStyles(styles) : deferredUseStyles;
}

export default createUseStyles;